var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-basic',[_c('v-container',{attrs:{"id":"billing-sec"}},[_c('v-row',[_c('v-col',{staticClass:"Full-Course-Library-Title"},[_vm._v("\n          Account Status : "+_vm._s(_vm.company.state_description)+"\n        ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }